import qs from 'qs';
import { IProduct } from 'types/IProduct';

import { TGetProductsParams } from 'services/api/productService';
import { useEffect, useState } from 'react';
import { api } from 'services/api';

interface IUseProductsWithCategory {
  params?: TGetProductsParams;
}

interface IUseProductsPaginatedReturn {
  productsData: IProduct[];
  hasMore: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
}

function useProductsPaginated(
  props?: IUseProductsWithCategory
): IUseProductsPaginatedReturn {
  const [productsData, setProductsData] = useState<IProduct[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [options, setOptions] = useState({
    page: 0,
    categories: '',
    sortBy: '',
    search: '',
    brand: '',
    attributes: '',
  });
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { params } = props || {};

  useEffect(() => {
    setOptions((previous) => {
      if (page === previous.page) {
        setProductsData([]);
        setHasMore(true);
        setPage(1);
      }

      return {
        page: page === previous.page ? 1 : page,
        categories: params.categories,
        sortBy: params.sortBy,
        search: params.search,
        brand: params.brand,
        attributes: params.attributes,
        status: 'active',
        showBrand: true,
        shouldGroupVariations: true,
      };
    });
  }, [
    params.categories,
    params.sortBy,
    page,
    params.search,
    params.brand,
    params.attributes,
  ]);

  useEffect(() => {
    (async (limit: number = 18) => {
      try {
        if (!hasMore || options.page === 0) {
          return;
        }

        if (page === 1) {
          setIsLoading(true);
        }
        const { data: response } = await api.get<IProduct[]>(
          `products/paginated?${qs.stringify(options)}`
        );

        if (response.length !== 0) {
          setProductsData((prev) => [...prev, ...response]);
        }
        setHasMore(response.length !== 0);
        if (page === 1) {
          setIsLoading(false);
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, [
    options.page,
    options.categories,
    options.sortBy,
    options.search,
    options.brand,
  ]);

  return { productsData, hasMore, setPage, isLoading };
}

export { useProductsPaginated };
